import { useNotifications } from '@10000/react'
import { Form } from '../forms'
import { Box } from '../widgets'
import { SettingsLayout } from './'
import './SettingsForm.scss'

export const SettingsForm = ({ onSubmit, values, gap = 16, children, ...props }) => {
  const { notify } = useNotifications()
  const handleSubmit = data => onSubmit(data)?.then(() => notify('Saved', 'info'))

  return (
    <Box fullWidth justifyContent="center">
      <Form onSubmit={handleSubmit} values={values} className="settings-form">
        <SettingsLayout {...props} buttonType="submit">
          <Box column gap={gap} fullWidth>
            {children}
          </Box>
        </SettingsLayout>
      </Form>
    </Box>
  )
}